import React from 'react';
import ReactDOM from 'react-dom/client';
// Side-effect import: begin capturing native keyboard geometry before React
// mounts, so the host's initial baseline is never missed.
import './lib/viewport/keyboardGeometryBootstrap';
import { App } from './App';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
